import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { Modal } from 'react-bootstrap';

import { theme } from '_constants/theme';
import { ICONS_ALIASES } from '_constants/icons';
import { selectError } from '_redux/payment/selector';

import Icon from '_components/atomic/Icon';
import Button from '_components/atomic/Button';

const { colors, devices, fontSizes, spaces } = theme;

const StyledModalBody = styled(Modal.Body)`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: ${spaces.large4X}px;
`;

const StyledCloseActionContainer = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  top: ${-spaces.large3X}px;
  right: 0;
  font-family: 'Aeonik';
  font-style: normal;
  font-size: ${fontSizes.regular}px;
  font-weight: 400;
  color: ${colors.white};
  cursor: pointer;
`;

const StyledIconContainer = styled.div`
  margin-right: ${spaces.small2X}px;
`;

const StyledConfirmActionContainer = styled.div`
  margin-top: ${spaces.small - 2}px;
`;

const StyledTitle = styled.div`
  margin-bottom: ${spaces.small - 2}px;
  font-family: 'Aeonik';
  font-style: normal;
  font-size: ${fontSizes.large2X}px;
  font-weight: 500;
  color: ${colors.gray[800]};
  text-align: center;
`;

const StyledErrorMessage = styled.div`
  margin-bottom: ${spaces.small - 2}px;
  font-family: 'Aeonik';
  font-style: normal;
  font-size: ${fontSizes.regular}px;
  font-weight: 400;
  color: ${colors.orange[600]};
  text-align: center;

  @media ${devices.tablet} {
    font-size: ${fontSizes.small}px;
  }
`;

const RequestFailedModal = ({ visible, onClose, onConfirm }) => {
  const error = useSelector(selectError);

  return (
    <Modal
      dialogClassName="request-failed-modal"
      show={visible}
      onHide={onClose}
      backdrop="static"
      keyboard={false}
      centered
    >
      <StyledModalBody>
        <StyledCloseActionContainer onClick={onClose}>
          <StyledIconContainer>
            <Icon alias={ICONS_ALIASES.close} color={theme.colors.white} />
          </StyledIconContainer>
          Close
        </StyledCloseActionContainer>
        <StyledTitle>Sorry, request failed!</StyledTitle>
        {error?.message && (
          <StyledErrorMessage>{error.message}</StyledErrorMessage>
        )}
        <StyledConfirmActionContainer>
          <Button
            color={theme.colors.indigo[600]}
            suffix={
              <Icon
                alias={ICONS_ALIASES.arrowRight}
                color={theme.colors.white}
              />
            }
            onClick={onConfirm}
          >
            OK
          </Button>
        </StyledConfirmActionContainer>
      </StyledModalBody>
    </Modal>
  );
};

RequestFailedModal.propTypes = {
  visible: PropTypes.bool,
  onClose: PropTypes.func,
  onConfirm: PropTypes.func,
};

export default RequestFailedModal;
